var _path, _path2, _path3, _path4, _path5, _path6, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2599 34.3884H19C18.0572 34.3884 17.5858 34.3884 17.2929 34.0955C17 33.8026 17 33.3312 17 32.3884V31.2764C17 30.7579 17 30.4987 17.1332 30.2672C17.2664 30.0356 17.4673 29.9188 17.8691 29.6851C20.5146 28.1464 24.2715 27.2803 26.7791 28.7759C26.9475 28.8764 27.0991 28.9977 27.2285 29.1431C27.7866 29.77 27.746 30.7161 27.1028 31.2775C26.9669 31.396 26.8222 31.486 26.6764 31.5172C26.7962 31.5033 26.911 31.4874 27.0206 31.4699C27.932 31.3245 28.697 30.8375 29.3974 30.3084L31.2046 28.9433C31.8417 28.462 32.7873 28.4619 33.4245 28.943C33.9982 29.3762 34.1736 30.0894 33.8109 30.6707C33.388 31.3487 32.7921 32.216 32.2199 32.7459C31.6469 33.2766 30.7939 33.7504 30.0975 34.0865C29.326 34.4589 28.4738 34.6734 27.6069 34.8138C25.8488 35.0983 24.0166 35.0549 22.2763 34.6964C21.2925 34.4937 20.2708 34.3884 19.2599 34.3884Z",
    fill: "#1177BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5858 15.5858C19.219 15.9526 19.0819 16.4593 19.0306 17.2498C20.249 17.2335 21.2335 16.249 21.2498 15.0306C20.4593 15.0819 19.9526 15.219 19.5858 15.5858Z",
    fill: "#84DCC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4142 15.5858C30.0474 15.219 29.5407 15.0819 28.7502 15.0306C28.7664 16.249 29.751 17.2336 30.9694 17.2498C30.9181 16.4593 30.781 15.9526 30.4142 15.5858Z",
    fill: "#84DCC8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4142 22.4142C30.0474 22.781 29.5407 22.9181 28.7502 22.9694C28.7665 21.751 29.751 20.7664 30.9694 20.7502C30.9181 21.5407 30.781 22.0474 30.4142 22.4142Z",
    fill: "#84DCC8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5858 22.4142C19.9526 22.781 20.4593 22.9181 21.2498 22.9694C21.2335 21.751 20.249 20.7665 19.0306 20.7502C19.0819 21.5407 19.219 22.0474 19.5858 22.4142Z",
    fill: "#84DCC8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18.75C21.0711 18.75 22.75 17.0711 22.75 15H27.25C27.25 17.0711 28.9289 18.75 31 18.75V19.25C28.9289 19.25 27.25 20.9289 27.25 23H22.75C22.75 20.9289 21.0711 19.25 19 19.25V18.75ZM25 20C25.5523 20 26 19.5523 26 19C26 18.4477 25.5523 18 25 18C24.4477 18 24 18.4477 24 19C24 19.5523 24.4477 20 25 20Z",
    fill: "#84DCC8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#ECEDEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon);
export default __webpack_public_path__ + "static/media/Feature-icon.061731852dc18496d87036ae8523a12b.svg";
export { ForwardRef as ReactComponent };